<!-- Layers section content for the merged view-options panel (see BusinessViewControls.vue, -->
<!-- which owns the trigger button, popover, and layer-panel-opener registration this renders inside). -->
<template>
    <div v-if="layers.length > 0" class="layer-pills">
        <small class="layers-description">
            Toggle layers to hide or show information throughout Gotoko.
        </small>
        <button
            v-for="layer in layers"
            :key="layer.type"
            class="layer-pill"
            :class="{ active: layer.visible }"
            :style="
                layer.visible
                    ? {
                          backgroundColor: layer.color,
                          borderColor: layer.color,
                      }
                    : {}
            "
            @click="$emit('toggle', layer.type, !layer.visible)"
        >
            <font-awesome-icon
                v-if="layer.icon"
                class="layer-icon"
                :icon="layer.icon"
                :style="layer.visible ? {} : { color: layer.color }"
            />
            <span>{{ layer.label }}</span>
        </button>
    </div>
</template>

<script setup lang="ts">
import { LayerType } from "@/composables/bpmn-manager/layer";

interface Layer {
    type: LayerType;
    label: string;
    color: string;
    icon?: string | string[];
    visible: boolean;
}

defineProps<{
    layers: Layer[];
}>();

defineEmits<{
    toggle: [type: LayerType, visible: boolean];
}>();
</script>

<style scoped lang="scss">
.layer-pills {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    min-width: 12rem;
}

.layers-description {
    font-size: 11px;
    color: var(--p-text-muted-color);
    margin: 0;
    line-height: 1.4;
    max-width: 12rem;
}

.layer-pill {
    width: 100%;
    padding: 3px 10px;
    border: 1px solid var(--p-content-border-color);
    background: transparent;
    color: var(--p-text-muted-color);
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    transition:
        background-color 0.15s ease,
        color 0.15s ease,
        border-color 0.15s ease;

    &:hover {
        background: var(--surface-background-mild);
        color: var(--p-content-color);
    }

    &.active {
        color: rgba(255, 255, 255, 0.75);

        &:hover {
            opacity: 0.9;
        }
    }
}

.layer-icon {
    font-size: 0.95rem;
}
</style>
